var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#74BBE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.223 213.958L134.042 240.688L164.955 231.996L145.098 257.199L162.882 283.93L132.77 272.764L112.877 297.967L114.148 265.892L84.0361 254.763L114.948 246.071L116.223 213.958",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.742 213.958L377.922 240.688L346.974 231.996L366.867 257.199L349.083 283.93L379.196 272.764L399.125 297.967L397.815 265.892L427.964 254.763L397.015 246.071L395.744 213.958",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.982 80.999L265.911 111.547H298.06L272.057 130.424L281.949 160.972L255.982 142.097L229.98 160.972L239.908 130.424L213.941 111.547H246.054L255.982 80.999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.982 431L265.911 400.451H298.06L272.057 381.539L281.949 350.991L255.982 369.866L229.98 350.991L239.908 381.539L213.941 400.451H246.054L255.982 431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFm);
export default __webpack_public_path__ + "static/media/FM.08e0240b332ac862d12ef858f5f99618.svg";
export { ForwardRef as ReactComponent };